import { DataService } from '@/config/dataService/dataService';

const YapilyService = {
  connectBank(payload = {}) {
    return DataService.post('api/connect-bank', payload);
  },

  disconnectBank() {
    return DataService.delete('api/disconnect-bank');
  },

  getInstitutions(countryCode = 'GB') {
    return DataService.get('api/bank-institutions', {
      params: {
        country_code: countryCode,
      },
    });
  },

  getConsentStatus(consentId) {
    return DataService.get(`api/bank-consents/${consentId}`);
  },

  getBanks() {
    return DataService.get('api/banks');
  },

  getTransactions(accountId) {
    return DataService.get(`api/transactions/${accountId}`);
  },
};

export default YapilyService;